<template>
    <div class="rc-currency">
      <label class="item-name"><i class="required" v-show="component.properties.required">*</i>{{initComponent.name}}</label>
      <div class="component-content">
        <el-input :class="{onlyread:component.properties.readonly}" disabled :placeholder="initComponent.properties.placeholder">
          <template slot="append">{{suffix}}</template>
        </el-input>
      </div>
    </div>
</template>

<script>
import { componentMixin } from '../mixins'
export default {
  name: 'rc-currency',
  props: ['initComponent'],
  mixins: [ componentMixin ],
  data () {
    return {
      component: this.initComponent
    }
  },
  computed: {
    suffix () {
      switch (this.component.properties.currencyType) {
        case '人民币' :
          return '¥'
        case '美元' :
          return '$'
      }
    }
  }

}
</script>

<style lang="scss">
  .rc-currency {
    .el-input-group__append {
      width: 36px;
      font-size: 14px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/form/components/currency/rc-currency.vue